"use strict";

var _classCallCheck = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trail = void 0;

var Utils_1 = require("../../../../Utils");

var Trail =
/*#__PURE__*/
function () {
  function Trail() {
    _classCallCheck(this, Trail);

    this.delay = 1;
    this.quantity = 1;
  }

  _createClass(Trail, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.delay !== undefined) {
        this.delay = data.delay;
      }

      if (data.quantity !== undefined) {
        this.quantity = data.quantity;
      }

      if (data.particles !== undefined) {
        this.particles = Utils_1.Utils.deepExtend({}, data.particles);
      }
    }
  }]);

  return Trail;
}();

exports.Trail = Trail;